import {
  enumWorkOrderStatus,
  WorkOrderStatus,
} from '@rematter/frontend-lib-api-client';
import { Badge, cn } from '@rematter/ui-web';

import { useTranslations } from '../../i18n/useTranslations';

type WorkOrderStatusBadgeProps = {
  status: WorkOrderStatus;
  className?: string;
};

const STATUS_BADGE_COLOR: Record<
  WorkOrderStatus,
  'neutral' | 'primary' | 'warning' | 'success' | 'failure'
> = {
  [enumWorkOrderStatus.Draft]: 'neutral',
  [enumWorkOrderStatus.Open]: 'primary',
  [enumWorkOrderStatus.InProgress]: 'warning',
  [enumWorkOrderStatus.Completed]: 'success',
  [enumWorkOrderStatus.Cancelled]: 'failure',
};

export const WorkOrderStatusBadge = ({
  status,
  className,
}: WorkOrderStatusBadgeProps) => {
  const t = useTranslations();

  const statusLabel =
    t.workOrdersView.statusTypes[
      status as keyof typeof t.workOrdersView.statusTypes
    ] || status;

  return (
    <Badge
      color={STATUS_BADGE_COLOR[status]}
      className={cn('@WorkOrderStatusBadge', className)}
    >
      {statusLabel}
    </Badge>
  );
};
